import React, { useEffect, useState } from "react";
import { getNpdesPermits } from "../api/client";

/** A banner when the POTW's NPDES permit is due for renewal (from 180 days before
 *  it expires), shown on the admin and coordinator dashboards. */
export default function NpdesAlertBar() {
  const [alert, setAlert] = useState<{ level: string; message: string } | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getNpdesPermits().then(r => setAlert(r.data.alert)).catch(() => {});
  }, []);

  if (!alert || dismissed) return null;
  const red = alert.level !== "application_due";
  return (
    <div role="status" style={{
      display: "flex", alignItems: "center", gap: 12, padding: "8px 24px", fontSize: 13,
      background: red ? "#fff5f5" : "#fffbeb", borderBottom: `1px solid ${red ? "#fc8181" : "#f6ad55"}`,
      color: red ? "#9b2c2c" : "#7b341e" }}>
      <strong style={{ whiteSpace: "nowrap" }}>NPDES Permit Renewal</strong>
      <span style={{ flex: 1 }}>{alert.message}</span>
      <button aria-label="Dismiss" onClick={() => setDismissed(true)}
        style={{ background: "none", border: "none", cursor: "pointer", fontSize: 14, color: "inherit" }}>✕</button>
    </div>
  );
}
